/* eslint-disable react/no-unknown-property, react/button-has-type */

import WarningIcon from '@material-ui/icons/Warning'
import styled, { css } from 'styled-components'

import theme, { rem } from '../../utils/theme'
import Flag from '../Flag'
import Icon from '../Icon'

export const StyledStackedNavLink = styled.div.withConfig({
  shouldForwardProp: prop => !['hasIcon', 'isActive', 'isChild', 'isProminent', 'isVariant'].includes(prop),
})`
  & > a,
  & > button {
    display: flex;
    align-items: center;
    width: 100%;
    height: var(--nav-item-height);
    border-radius: calc(var(--nav-item-height) / 2);
    appearance: none;
    font-family: ${theme.typography.defaultFont};
    font-size: var(--nav-item-font-size);
    font-weight: ${theme.typography.fontWeightBolder};
    color: ${`var(--gameday-newDropdown-textColor, ${theme.newDropdown.textColor})`};
    text-align: left;
    text-decoration: none;
    padding: var(--nav-item-padding);
    transition: ${theme.transitions.short};
    cursor: pointer;
    position: relative;

    &:hover,
    li:hover > & {
      background-color: ${`var(--gameday-newDropdown-buttonBgColorHover, ${theme.newDropdown.buttonBgColorHover})`};
      color: ${`var(--gameday-newDropdown-textColor, ${theme.newDropdown.textColor})`};
    }

    &:focus {
      outline: 0;
      box-shadow: ${theme.focusRings.shadow({ inset: true })};
    }

    ${props =>
      props.isProminent &&
      css`
        background-color: ${`var(--gameday-newDropdown-buttonBgColorProminent, ${theme.newDropdown.buttonBgColorProminent})`};

        &:hover,
        li:hover > & {
          background-color: ${`var(--gameday-newDropdown-buttonBgColorProminentHover, ${theme.newDropdown.buttonBgColorProminentHover})`};
        }
      `}

    ${props =>
      (props.isActive && !props.isChild) ||
      (
        props.isVariant &&
          css`
          background-color: ${`var(--gameday-newDropdown-buttonBgColorProminent, ${theme.newDropdown.buttonBgColorProminent})`};
        `
      )}

    ${props =>
      props.isActive &&
      props.isChild &&
      css`
        color: ${`var(--gameday-newDropdown-textColorActive, ${theme.newDropdown.textColorActive})`};
        background-color: ${`var(--gameday-newDropdown-buttonBgColor, ${theme.newDropdown.buttonBgColor})`};
      `}


    ${props =>
      props.hasIcon === 'new' &&
      css`
        justify-content: space-between;
      `}

      ${props =>
        props.isVariant &&
        css`
        &:hover,
        &:focus {
          color: ${`var(--gameday-newDropdown-textColorActive, ${theme.newDropdown.textColorActive})`} !important;
        }
      `}

    svg {
      font-size: 1.2rem;
      margin-right: 0.1rem;
    }
  }
`
const StyledLeftWrap = styled.div`
  display: flex;
  align-items: center;
`

const StyledIcon = styled.span.withConfig({
  shouldForwardProp: prop => !['isCollapsed', 'parentIconColor', 'isProfileNav'].includes(prop),
})`
  color: ${`var(--gameday-mainNav-iconColor, ${theme.mainNav.iconColor})`};
  transition: ${theme.mainNav.transition};
  transform: translateX(-10px);
  ${props =>
    props.isCollapsed &&
    css`
      transform: translateX(-15px);
    `}

  ${props =>
    props.parentIconColor &&
    css`
      color: ${props.parentIconColor};
    `}

  ${props =>
    props.isProfileNav &&
    css`
      transform: translateX(-2px) translateY(3px);
    `}
`

const StyledLabel = styled.span.withConfig({
  shouldForwardProp: prop => !['isCollapsed'].includes(prop),
})`
  transition: ${theme.mainNav.transition};
  ${props =>
    props.isCollapsed &&
    css`
      opacity: 0;
    `}
`

const StyledAlert = styled.span.withConfig({
  shouldForwardProp: prop => !['isParent', 'alert'].includes(prop),
})`
  display: flex;
  align-items: center;
  margin: 0 ${rem(-10)} 0 auto;
  padding: ${rem(2)} 0 0 0;

  ${props =>
    props.isParent &&
    css`
      margin: 0 ${rem(20)} 0 auto;
    `}

  ${props =>
    props.alert === 'success' &&
    css`
      color: ${`var(--gameday-status-successColor, ${theme.status.successColor})`};
    `}

  ${props =>
    props.alert === 'warning' &&
    css`
      color: ${`var(--gameday-status-warningColor, ${theme.status.warningColor})`};
    `}

  ${props =>
    props.alert === 'error' &&
    css`
      color: ${`var(--gameday-status-errorColor, ${theme.status.errorColor})`};
    `}
`

const StyledFlag = styled.div`
  position: absolute;
  right: ${rem(10)};

  ${props =>
    props.isCollapsed &&
    css`
      opacity: 0;
      transform: translateX(110%);
      right: -110%;
    `}
`

function StackedNavLink(props) {
  const {
    type = 'link',
    label,
    href,
    onClick,
    tabIndex = 0,
    isExternal,
    isProminent,
    isActive,
    isParent,
    isChild,
    customComponent,
    parentIcon,
    parentIconColor,
    isCollapsed,
    icon,
    alert,
    isProfileNav,
    isVariant,
  } = props

  return (
    <StyledStackedNavLink
      isActive={isActive}
      isChild={isChild}
      isprominent={isProminent}
      hasIcon={icon}
      isVariant={isVariant}
    >
      {customComponent}
      {!customComponent && type === 'link' && (
        // biome-ignore lint/complexity/noUselessFragments: TODO
        <>
          {isExternal ? (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              onClick={onClick}
              isprominent={isProminent}
              tabIndex={tabIndex}
            >
              <StyledLeftWrap>
                {parentIcon && (
                  <StyledIcon isCollapsed={isCollapsed} parentIconColor={parentIconColor} isProfileNav={isProfileNav}>
                    {parentIcon && typeof parentIcon === 'string' ? (
                      <Icon iconSize={32} viewBox="0 0 32 32" iconName={parentIcon} />
                    ) : (
                      parentIcon
                    )}
                  </StyledIcon>
                )}
                <StyledLabel isCollapsed={isCollapsed}>{label}</StyledLabel>
              </StyledLeftWrap>
              {icon && icon !== 'arrow' && (
                <StyledFlag isCollapsed={isCollapsed}>
                  <Flag variant={icon} title={icon} />
                </StyledFlag>
              )}
              {alert && (
                <StyledAlert isParent={isParent} alert={alert}>
                  <WarningIcon size="sm" />
                </StyledAlert>
              )}
            </a>
          ) : (
            <a href={href} onClick={onClick} isprominent={isProminent} tabIndex={tabIndex}>
              <StyledLeftWrap>
                {parentIcon && (
                  <StyledIcon isCollapsed={isCollapsed} parentIconColor={parentIconColor} isProfileNav={isProfileNav}>
                    {parentIcon && typeof parentIcon === 'string' ? (
                      <Icon iconSize={32} viewBox="0 0 32 32" iconName={parentIcon} />
                    ) : (
                      parentIcon
                    )}
                  </StyledIcon>
                )}
                <StyledLabel isCollapsed={isCollapsed}>{label}</StyledLabel>
              </StyledLeftWrap>
              {icon && icon !== 'arrow' && (
                <StyledFlag isCollapsed={isCollapsed}>
                  <Flag variant={icon} title={icon} />
                </StyledFlag>
              )}
              {alert && (
                <StyledAlert isParent={isParent} alert={alert}>
                  <WarningIcon size="sm" />
                </StyledAlert>
              )}
            </a>
          )}
        </>
      )}
      {!customComponent && type === 'button' && (
        // biome-ignore lint/a11y/useButtonType: TODO
        <button onClick={onClick} isprominent={isProminent} tabIndex={tabIndex}>
          {label}
        </button>
      )}
    </StyledStackedNavLink>
  )
}

export default StackedNavLink
